// extracted by mini-css-extract-plugin
export default {"navButton":"MainNavbar_navButton__Z0G92","avatar":"MainNavbar_avatar__ZCGuM"};